"use client";

import React, { useState, useEffect } from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
const restaurants = {
  en: {
    title: "Where to Eat",
    subtitle: "",
    sections: [{
      heading: "Restaurants",
      items: [{
        name: "Coromandel",
        note: "Excellent, especially for brunch"
      }, {
        name: "Osteria Coppelle",
        note: "In Piazza delle Coppelle, a personal favourite"
      }, {
        name: "Giulio Passami l'Olio",
        note: "Very good and wonderfully welcoming"
      }, {
        name: "La Fraschetta di Castel Sant Angelo",
        note: "Great food, right by Castel Sant Angelo"
      }, {
        name: "Da Tonino",
        note: "A traditional Roman trattoria"
      }, {
        name: "Osteria da Fortunata",
        note: "Good, though it has become quite touristy"
      }, {
        name: "Ciack",
        note: "Very good Roman restaurant in Trastevere"
      }]
    }, {
      heading: "Street Food",
      items: [{
        name: "All'Antico Vinaio",
        note: "Excellent, especially for brunch"
      }, {
        name: "Trapizzino",
        note: "A Roman street food classic"
      }, {
        name: "Mercato Centrale",
        note: "Great for variety and casual bites"
      }]
    }, {
      heading: "Aperitivo",
      note: "Traditional Italian pre-dinner ritual, much like a happy hour.",
      items: [{
        name: "The Court Rooftop",
        note: "Amazing drinks with a Colosseum view. Reservations recommended"
      }, {
        name: "Il Bar del Fico",
        note: ""
      }, {
        name: "Bar della Pace",
        note: ""
      }, {
        name: "Pantheon Hotel Rooftop",
        note: "Stunning rooftop views"
      }, {
        name: "Six Senses",
        note: "Rooftop"
      }, {
        name: "Coffee Pot",
        note: "Sushi and aperitivo in Trastevere"
      }, {
        name: "Pimms Good",
        note: "Great for aperitivo in Trastevere"
      }]
    }, {
      heading: "Pizza",
      items: [{
        name: "Grottino",
        note: "Testaccio, the best thin Roman pizza. No reservations, queue required but absolutely worth it"
      }, {
        name: "Romolo e Remo",
        note: "Also Testaccio, queue but short wait"
      }, {
        name: "L'Elementare",
        note: "Recently opened and already a favourite"
      }]
    }, {
      heading: "Breakfast and Dessert",
      items: [{
        name: "Regoli",
        note: "Best maritozzo con la panna in Rome, and an incredible strawberry cream tart"
      }, {
        name: "Pasticceria al Ghetto",
        note: "Ancient bakery famous for its ricotta and sour cherry tart"
      }, {
        name: "Pasticceria Linari",
        note: "Testaccio, excellent for breakfast"
      }, {
        name: "Fior di Luna",
        note: "Great gelato in Trastevere"
      }]
    }]
  },
  it: {
    title: "Dove Mangiare",
    subtitle: "",
    sections: [{
      heading: "Ristoranti",
      items: [{
        name: "Coromandel",
        note: "Davvero ottimo, soprattutto per il brunch"
      }, {
        name: "Osteria Coppelle",
        note: "In Piazza delle Coppelle, uno dei preferiti"
      }, {
        name: "Giulio Passami l'Olio",
        note: "Molto buono e super accogliente"
      }, {
        name: "La Fraschetta di Castel Sant Angelo",
        note: "Molto buono, vicino a Castel Sant Angelo"
      }, {
        name: "Da Tonino",
        note: "Una trattoria romana tradizionale"
      }, {
        name: "Osteria da Fortunata",
        note: "Buono, ma e diventato piuttosto turistico"
      }, {
        name: "Ciack",
        note: "Ristorante romano molto buono a Trastevere"
      }]
    }, {
      heading: "Street Food",
      items: [{
        name: "All'Antico Vinaio",
        note: "Ottimo per qualcosa di veloce"
      }, {
        name: "Trapizzino",
        note: "Classico street food romano"
      }, {
        name: "Mercato Centrale",
        note: "Ottimo per avere piu scelta"
      }]
    }, {
      heading: "Aperitivo",
      note: "Il classico rito prima di cena, simile a un happy hour.",
      items: [{
        name: "The Court Rooftop",
        note: "Vista mozzafiato del Colosseo (prenotazione consigliata)"
      }, {
        name: "Il Bar del Fico",
        note: ""
      }, {
        name: "Bar della Pace",
        note: ""
      }, {
        name: "Rooftop del Pantheon Hotel",
        note: "Vista mozzafiato"
      }, {
        name: "Six Senses",
        note: "Rooftop"
      }, {
        name: "Coffee Pot",
        note: "Sushi e aperitivo a Trastevere"
      }, {
        name: "Pimms Good",
        note: "Per aperitivo a Trastevere"
      }]
    }, {
      heading: "Pizza",
      items: [{
        name: "Grottino",
        note: "Testaccio, la migliore pizza romana bassa. Niente prenotazioni, bisogna fare la fila ma ne vale la pena"
      }, {
        name: "Romolo e Remo",
        note: "Sempre a Testaccio, fila breve"
      }, {
        name: "L'Elementare",
        note: "Aperto da poco ma gia amatissimo"
      }]
    }, {
      heading: "Colazione e Dolci",
      items: [{
        name: "Regoli",
        note: "Il miglior maritozzo con la panna di Roma e una torta crema e fragoline imperdibile"
      }, {
        name: "Pasticceria al Ghetto",
        note: "Pasticceria antichissima famosa per la torta con ricotta e visciole"
      }, {
        name: "Pasticceria Linari",
        note: "Zona Testaccio, ottima per colazione"
      }, {
        name: "Fior di Luna",
        note: "Ottimo gelato a Trastevere"
      }]
    }]
  }
};
const placesToSee = {
  en: [{
    heading: "Neighborhoods",
    items: [{
      name: "Historical Center",
      note: "Filled with the most iconic Roman sights"
    }, {
      name: "Monti",
      note: "Next to Colosseum. Great for a late night"
    }, {
      name: "Trastevere",
      note: "Historic neighborhood located across Tiber River. Filled with locals"
    }, {
      name: "Jewish Ghetto",
      note: "A beautiful area, rich with history and exceptional Roman-Jewish cuisine (Ba Ghetto is a great restaurant)"
    }, {
      name: "Giannicolo",
      note: "A hill in Rome, known for its panoramic views and its daily firing of a cannon at noon"
    }]
  }, {
    heading: "Walking Around",
    items: [{
      name: "Shopping",
      note: "Via del Corso and Via Condotti are two famous shopping streets near the Spanish Steps"
    }, {
      name: "Parks",
      note: "Villa Borghese and Villa Pamphili"
    }, {
      name: "Museums",
      note: "Galleria Borghese and Galleria d'Arte Moderna"
    }, {
      name: "Markets",
      note: "Mercato di Porta Portese for a local vintage experience. Mercato di Testaccio for typical street food"
    }]
  }],
  it: [{
    heading: "Quartieri",
    items: [{
      name: "Centro Storico",
      note: "Ricco dei monumenti più iconici di Roma"
    }, {
      name: "Monti",
      note: "Accanto al Colosseo. Perfetto anche per la sera"
    }, {
      name: "Trastevere",
      note: "Quartiere storico oltre il Tevere, molto frequentato dai locali"
    }, {
      name: "Ghetto Ebraico",
      note: "Una zona splendida, ricca di storia e con un’eccezionale cucina romano-ebraica (Ba Ghetto è un ottimo ristorante)"
    }, {
      name: "Gianicolo",
      note: "Una collina di Roma famosa per i panorami e per lo sparo del cannone a mezzogiorno"
    }]
  }, {
    heading: "Passeggiare per Roma",
    items: [{
      name: "Shopping",
      note: "Via del Corso e Via Condotti sono due famose vie dello shopping vicino a Piazza di Spagna"
    }, {
      name: "Parchi",
      note: "Villa Borghese e Villa Pamphili"
    }, {
      name: "Musei",
      note: "Galleria Borghese e Galleria d’Arte Moderna"
    }, {
      name: "Mercati",
      note: "Mercato di Porta Portese per un’esperienza vintage locale. Mercato di Testaccio per lo street food tipico"
    }]
  }]
};
const faqItems = {
  en: [{
    question: "When should I arrive at the ceremony?",
    answer: "We recommend arriving at least 15 minutes early, ideally around 3:45 PM. The ceremony will begin promptly at 4:00 PM."
  }, {
    question: "How far is the ceremony from the reception?",
    answer: "The church and the Rome Cavalieri Waldorf Astoria are approximately a 10 to 15 minute drive apart, possibly a little longer depending on traffic."
  }, {
    question: "Where should I park?",
    answer: "There is a parking area near the church, further details to come. At the reception, the Waldorf Astoria offers valet and a parking garage, though neither are free. There is usually ample free street parking just outside the hotel."
  }, {
    question: "What is the dress code?",
    answer: "The dress code is Formal Attire. Women typically wear midi or full-length dresses, jumpsuits, or elegant suits. Men would wear suits or a blazer with dress trousers. Feel free to wear colour, we love it!"
  }, {
    question: "Where should I stay?",
    answer: "We have curated a selection of hotel and Airbnb recommendations on our Travel and Stay page. We suggest booking as early as possible as Rome fills up quickly in September."
  }, {
    question: "When is the RSVP deadline?",
    answer: "Please RSVP as soon as possible, and no later than August 1st 2026."
  }, {
    question: "Are children welcome?",
    answer: "Absolutely, we cannot wait to celebrate with your little ones!"
  }, {
    question: "What is the weather like in Rome in September?",
    answer: "September in Rome is generally beautiful, warm and sunny during the day with temperatures typically between 20 and 28 degrees celsius. Evenings can be cooler so we recommend bringing a light jacket or wrap."
  }, {
    question: "What should I do if I have dietary restrictions?",
    answer: "There is a dedicated section on the RSVP form for dietary requirements. Please make sure to fill this in so we can ensure the kitchen is fully prepared for you."
  }, {
    question: "Will there be transportation between venues?",
    answer: "Transportation details will be shared closer to the wedding weekend."
  }, {
    question: "Is there a wedding gift registry?",
    answer: "Your presence in Rome is the greatest gift we could ask for. However if you would like to contribute something, we have a registry available on our Registry page."
  }, {
    question: "Can I take photos during the ceremony?",
    answer: "We kindly ask that guests refrain from taking photos during the ceremony so that everyone can be fully present. Our photographer will capture every moment. Feel free to take as many photos as you like during the aperitivo, dinner, and after party!"
  }],
  it: [{
    question: "A che ora devo arrivare alla cerimonia?",
    answer: "Vi consigliamo di arrivare con almeno 15 minuti di anticipo, idealmente intorno alle 15:45. La cerimonia iniziera puntualmente alle 16:00."
  }, {
    question: "Quanto dista la cerimonia dal ricevimento?",
    answer: "La chiesa e il Rome Cavalieri Waldorf Astoria distano circa 10-15 minuti in auto, forse qualcosa in piu a seconda del traffico."
  }, {
    question: "Dove posso parcheggiare?",
    answer: "C'e un parcheggio vicino alla chiesa, i dettagli saranno comunicati piu avanti. Al ricevimento, il Waldorf Astoria offre valet parking e un garage, anche se nessuno dei due e gratuito. Di solito c'e abbondante parcheggio gratuito in strada appena fuori dall'hotel."
  }, {
    question: "Qual e il dress code?",
    answer: "Il dress code e Abito Formale. Le donne solitamente indossano abiti midi o lunghi, tute eleganti o completi. Gli uomini indossano abiti o giacca con pantaloni eleganti. Sentitevi liberi di indossare colori, li adoriamo!"
  }, {
    question: "Dove mi conviene alloggiare?",
    answer: "Abbiamo raccolto una selezione di hotel e Airbnb consigliati nella nostra pagina Travel and Stay. Vi suggeriamo di prenotare il prima possibile poiche Roma si riempie in fretta a settembre."
  }, {
    question: "Entro quando devo confermare la presenza?",
    answer: "Vi chiediamo di confermare la presenza il prima possibile, e comunque entro il 1 agosto 2026."
  }, {
    question: "I bambini sono i benvenuti?",
    answer: "Assolutamente si, non vediamo l'ora di festeggiare con i vostri piccoli!"
  }, {
    question: "Com'e il tempo a Roma a settembre?",
    answer: "Settembre a Roma e generalmente splendido, caldo e soleggiato durante il giorno con temperature tra i 20 e i 28 gradi. Le serate possono essere piu fresche quindi vi consigliamo di portare una giacca leggera."
  }, {
    question: "Cosa faccio se ho restrizioni alimentari?",
    answer: "Nel modulo RSVP c'e una sezione dedicata alle esigenze alimentari. Assicuratevi di compilarla in modo che la cucina possa essere pienamente preparata per voi."
  }, {
    question: "Ci sara un servizio di trasporto tra le location?",
    answer: "I dettagli sul trasporto saranno comunicati piu vicino al weekend del matrimonio."
  }, {
    question: "C'e una lista nozze?",
    answer: "La vostra presenza a Roma e il regalo piu grande che potessimo desiderare. Se tuttavia desiderate contribuire con qualcosa, abbiamo una lista nozze disponibile nella pagina Registry."
  }, {
    question: "Posso scattare foto durante la cerimonia?",
    answer: "Vi chiediamo gentilmente di non scattare foto durante la cerimonia per permettere a tutti di essere pienamente presenti. Il nostro fotografo immortalera ogni momento. Sentitevi liberi di scattare foto durante l'aperitivo, la cena e il dopo festa!"
  }]
};
export default function FrequentlyAskedQuestions() {
  const [language, setLanguage] = useState<"en" | "it">("en");
  useEffect(() => {
    const savedLanguage = localStorage.getItem("site-language");
    if (savedLanguage === "en" || savedLanguage === "it") {
      setLanguage(savedLanguage);
    }
  }, []);
  useEffect(() => {
    const handleStorageChange = () => {
      const savedLanguage = localStorage.getItem("site-language");
      if (savedLanguage === "en" || savedLanguage === "it") {
        setLanguage(savedLanguage);
      }
    };
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("focus", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("focus", handleStorageChange);
    };
  }, []);
  const r = restaurants[language];
  const sights = placesToSee[language];
  const content = faqItems[language];
  const t = {
    en: {
      eyebrow: "Recommendations",
      title: "Rome Recommendations & FAQ",
      intro: "A few of our favorite spots, ideas for what to see, and some helpful details for the wedding weekend.",
      eatTab: "Where to Eat",
      seeTab: "Things to Do",
      faqTab: "FAQ"
    },
    it: {
      eyebrow: "Consigli",
      title: "Consigli su Roma & FAQ",
      intro: "Alcuni dei nostri posti preferiti, idee su cosa vedere e qualche dettaglio utile per il weekend del matrimonio.",
      eatTab: "Dove Mangiare",
      seeTab: "Cose da Fare",
      faqTab: "FAQ"
    }
  }[language];
  return <section data-section-id="3913" id="domande-frequenti" className="bg-background py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center mb-20">
          <h2 className="text-xs tracking-[0.3em] uppercase text-primary mb-4">
            {t.eyebrow}
          </h2>

          <h1 className="font-serif text-5xl sm:text-6xl text-foreground leading-tight">
            {t.title}
          </h1>

          <p className="mt-6 text-lg leading-8 text-muted-foreground">
            {t.intro}
          </p>
        </div>

        <Tabs defaultValue="eat" className="w-full flex flex-col items-center">
          <TabsList className="mb-14 grid w-full grid-cols-1 gap-3 bg-transparent p-0 h-auto shadow-none sm:grid-cols-3 sm:max-w-2xl sm:gap-4">
            <TabsTrigger value="eat" className="min-h-[52px] rounded-none border border-primary/30 bg-background px-4 py-3 text-[11px] tracking-[2px] uppercase text-foreground/80 transition-all duration-300 hover:border-primary/50 hover:shadow-md data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-md sm:px-6 sm:py-4 sm:text-[12px] sm:tracking-[3px]">
              {t.eatTab}
            </TabsTrigger>

            <TabsTrigger value="see" className="min-h-[52px] rounded-none border border-primary/30 bg-background px-4 py-3 text-[11px] tracking-[2px] uppercase text-foreground/80 transition-all duration-300 hover:border-primary/50 hover:shadow-md data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-md sm:px-6 sm:py-4 sm:text-[12px] sm:tracking-[3px]">
              {t.seeTab}
            </TabsTrigger>

            <TabsTrigger value="faq" className="min-h-[52px] rounded-none border border-primary/30 bg-background px-4 py-3 text-[11px] tracking-[2px] uppercase text-foreground/80 transition-all duration-300 hover:border-primary/50 hover:shadow-md data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-md sm:px-6 sm:py-4 sm:text-[12px] sm:tracking-[3px]">
              {t.faqTab}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="eat" className="w-full mt-0">
            <Accordion type="single" collapsible className="w-full">
              {r.sections.map((section, si) => <AccordionItem key={`${language}-eat-${si}`} value={`eat-${si}`} className="border-border border-b">
                  <AccordionTrigger className="group py-6 sm:py-8 px-3 sm:px-4 text-left hover:no-underline hover:bg-secondary/40 transition-all duration-300 [&>svg]:hidden">
                    <div className="flex w-full items-start justify-between gap-4">
                      <div className="pr-2">
                        <span className="block text-lg sm:text-xl font-serif italic text-foreground transition-colors duration-300 group-hover:text-primary leading-snug">
                          {section.heading}
                        </span>
                        {section.note && <span className="mt-2 block text-sm text-muted-foreground font-sans italic normal-case tracking-normal">
                            {section.note}
                          </span>}
                      </div>
                      <Plus strokeWidth={1} className="mt-1 text-primary size-5 shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-45" />
                    </div>
                  </AccordionTrigger>

                  <AccordionContent className="px-3 sm:px-4 pb-6 sm:pb-8">
                    <div className="border-t border-primary/10">
                      {section.items.map((item, ii) => <div key={ii} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4 py-4 border-b border-border last:border-b-0">
                          <span className="font-serif text-lg text-foreground sm:min-w-[200px]">
                            {item.name}
                          </span>
                          {item.note && <span className="text-sm text-muted-foreground font-sans italic">
                              {item.note}
                            </span>}
                        </div>)}
                    </div>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </TabsContent>

          <TabsContent value="see" className="w-full mt-0">
            <Accordion type="single" collapsible className="w-full">
              {sights.map((section, si) => <AccordionItem key={`${language}-see-${si}`} value={`see-${si}`} className="border-border border-b">
                  <AccordionTrigger className="group py-6 sm:py-8 px-3 sm:px-4 text-left hover:no-underline hover:bg-secondary/40 transition-all duration-300 [&>svg]:hidden">
                    <div className="flex w-full items-start justify-between gap-4">
                      <span className="pr-2 text-lg sm:text-xl font-serif italic text-foreground transition-colors duration-300 group-hover:text-primary leading-snug">
                        {section.heading}
                      </span>
                      <Plus strokeWidth={1} className="mt-1 text-primary size-5 shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-45" />
                    </div>
                  </AccordionTrigger>

                  <AccordionContent className="px-3 sm:px-4 pb-6 sm:pb-8">
                    <div className="border-t border-primary/10">
                      {section.items.map((item, ii) => <div key={ii} className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4 py-4 border-b border-border last:border-b-0">
                          <span className="font-serif text-lg text-foreground sm:min-w-[200px]">
                            {item.name}
                          </span>
                          {item.note && <span className="text-sm text-muted-foreground font-sans italic">
                              {item.note}
                            </span>}
                        </div>)}
                    </div>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </TabsContent>

          <TabsContent value="faq" className="w-full mt-0">
            <Accordion type="single" collapsible className="w-full">
              {content.map((item, i) => <AccordionItem key={`${language}-${i}`} value={`item-${i}`} className="border-border border-b" data-index={i}>
                  <AccordionTrigger className="group py-6 sm:py-8 px-3 sm:px-4 text-left hover:no-underline hover:bg-secondary/40 transition-all duration-300 [&>svg]:hidden">
                    <div className="flex w-full items-start justify-between gap-4">
                      <span className="pr-2 text-lg sm:text-xl font-serif italic text-foreground transition-colors duration-300 group-hover:text-primary leading-snug">
                        {item.question}
                      </span>
                      <Plus strokeWidth={1} className="mt-1 text-primary size-5 shrink-0 transition-transform duration-300 group-data-[state=open]:rotate-45" />
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-3 sm:px-4 pb-6 sm:pb-8 text-sm sm:text-base leading-relaxed text-muted-foreground font-sans">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </TabsContent>
        </Tabs>
      </div>
    </section>;
}